export default __webpack_public_path__ + "static/media/kangaroo-sitting.afb9115a.png";